export const APP_BAR_PAGE_TITLE_MAX_WIDTH_IN_PIXELS = 250
